import { render, staticRenderFns } from "./OrkestroSettings.vue?vue&type=template&id=eb6a4e46"
import script from "./OrkestroSettings.vue?vue&type=script&lang=js"
export * from "./OrkestroSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports